import { render, staticRenderFns } from "./ChevronY.vue?vue&type=template&id=3383f7fe&lang=pug&"
import script from "./ChevronY.vue?vue&type=script&lang=js&"
export * from "./ChevronY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports